// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "alert";
var _3 = "alertDanger";
var _4 = "alertSuccess";
var _5 = "alertWarning";
var _6 = "base-link";
var _7 = "#000000";
var _8 = "#76F366";
var _9 = "#EB8632";
var _a = "#ECC834";
var _b = "#21FC87";
var _c = "#EA4A30";
var _d = "#C7EA45";
var _e = "#272B2B";
var _f = "#BDBDBD";
var _10 = "#7D7D7D";
var _11 = "#6A0DAD";
var _12 = "#3A65FF";
var _13 = "#4A90E2";
var _14 = "#ffffff";
var _15 = "reset-button";
var _16 = "rounded";
var _17 = "1200px";
var _18 = "992px";
var _19 = "1366px";
var _1a = "768px";
var _1b = "1475px";
var _1c = "576px";
var _1d = "1600px";
var _1e = "320px";
var _1f = "2500px";
var _20 = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "alert", _3 as "alertDanger", _4 as "alertSuccess", _5 as "alertWarning", _6 as "base-link", _7 as "colorBlack", _8 as "colorGradeEX", _9 as "colorGradeFR", _a as "colorGradeGD", _b as "colorGradeOU", _c as "colorGradePR", _d as "colorGradeVG", _e as "colorNeutral", _f as "colorNeutralLighest", _10 as "colorNeutralLight", _11 as "colorNonOwnerSweetLine", _12 as "colorOwnerSweetLine", _13 as "colorRegularLinks", _14 as "colorWhite", _15 as "reset-button", _16 as "rounded", _17 as "screenlg", _18 as "screenmd", _19 as "screenml", _1a as "screensm", _1b as "screenxlg", _1c as "screenxs", _1d as "screenxxlg", _1e as "screenxxs", _1f as "screenxxxlg", _20 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "alert": _2, "alertDanger": _3, "alertSuccess": _4, "alertWarning": _5, "base-link": _6, "colorBlack": _7, "colorGradeEX": _8, "colorGradeFR": _9, "colorGradeGD": _a, "colorGradeOU": _b, "colorGradePR": _c, "colorGradeVG": _d, "colorNeutral": _e, "colorNeutralLighest": _f, "colorNeutralLight": _10, "colorNonOwnerSweetLine": _11, "colorOwnerSweetLine": _12, "colorRegularLinks": _13, "colorWhite": _14, "reset-button": _15, "rounded": _16, "screenlg": _17, "screenmd": _18, "screenml": _19, "screensm": _1a, "screenxlg": _1b, "screenxs": _1c, "screenxxlg": _1d, "screenxxs": _1e, "screenxxxlg": _1f, "single-page-responsive-font-size": _20 }
